import { c as _c } from "react/compiler-runtime";
import { FlexCenter, NumberDisplay, SkeletonLine, TextBody } from "@opensea/ui-kit";
import { LocalGasStationFilled } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useAccount } from "@opensea/wallet";
import { useTranslations } from "next-intl";
import { useEstimateFeesPerGas } from "wagmi";
export function PageFooterGwei() {
  const $ = _c(13);
  const {
    chainId
  } = useAccount();
  const t = useTranslations("PageFooterGwei");
  const t0 = chainId || 1;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      chainId: t0,
      formatUnits: "gwei"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const result = useEstimateFeesPerGas(t1);
  if (!result.data?.maxFeePerGas) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <SkeletonLine className="h-5 w-[76px]" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LocalGasStationFilled size={14} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== result.data.maxFeePerGas) {
    t3 = bn(result.data.maxFeePerGas).div(1000000000);
    $[4] = result.data.maxFeePerGas;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <NumberDisplay display="quantity" value={t3} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("gwei");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <FlexCenter className="gap-1 text-text-secondary">{t2}<TextBody size="xs">{t4}{" "}{t5}</TextBody></FlexCenter>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}